export const normalizeTable = (editor) => {
  // Normalization rules for table cells

  return editor;
};
